import { useResourceNavigate } from "@/hooks/useResourceNavigate";
import { useResourceContext } from "@/layouts/ResourceContext";
import {
  DeleteOutlined,
  DownOutlined,
  PlayCircleOutlined,
  StopOutlined,
} from "@ant-design/icons";
import { Button, Modal, Dropdown, Space } from "antd";
import { useTranslation } from "react-i18next";
import { useUpdate, useDelete, useInvalidate, useCan, CanAccess } from "@refinedev/core";
import { useResourceUpdate } from "@/hooks";
import { RefreshButton } from "@/components/common/RefreshButton";

const RESOURCE = "instances";

export const AddonActions = (props) => {
  const { t } = useTranslation();
  const { state, dispatch } = useResourceContext();
  const [ selectedInstance ] = state.selectedResources;
  const navigate = useResourceNavigate();
  const addonId = props.addonId;
  const addonName = props.addonName;

  const clickAction = props.clickAction;

  const navigateToCreation = () => {
    navigate({ resource: RESOURCE, action: 'create' });
  };
  const { mutate: deleteMutate } = useDelete();
  const { mutate, isLoading: isUpdating } = useUpdate({
    successNotification: (response, { id, values }, resource) =>{
      const { action, data } = values;
      return {
        message: t(`addon.actionResult.${action}.success`, {addonName}),
        description: 'Success',
        type: "success"
      }
    },
  });

  const { data: allowEdit } = useCan({action:"edit", resource:"addons"});
  const { data: allowDelete } = useCan({action: "delete", resource: "addons"});

  const lifecycleMenu = [
    { key: 'enable', label: <span><PlayCircleOutlined /> Enable</span>, disabled: !addonId || !allowEdit?.can },
    { key: 'disable', label: <span><StopOutlined /> Disable</span> , disabled: !addonId || !allowEdit?.can},
    { key: 'uninstall', label: <span><DeleteOutlined /> Uninstall</span> , disabled: !addonId || !allowDelete?.can },
  ];
  const actionsMenu = [
    { key: 'view', label: t('nodegroups.menu.details'), disabled: !addonId },
    { key: 'edit', label: 'Edit Add-on', disabled: !addonId || !allowEdit?.can },   
  ];

  const onClickLifecycle = (item) => {
    const [ selectedAddon ] = state.selectedResources
    console.log('Lifecycle:', selectedAddon.id, item.key);
    if (item.key === "uninstall") {
      Modal.confirm({
        title: t("addon.deleteConfirm", "Uninstall Add-on"),
        content: t("addon.deleteConfirmContent", `This action cannot be undone. Are you sure you want to uninstall this add-on ${addonName}?`),
        centered: true,
        onOk: () => {
          deleteMutate({
            resource: "addons",
            id: selectedAddon.id,
            meta: {
              addonId : addonId
            }
          });
        },
        onCancel: () => {
          console.log("Cancel delete");
        },
      });
    } else {
      mutate({
        resource: "addons",
        id: selectedAddon.id,
        values: {
          action: item.key,
          addonId : addonId
        }
      });
    }
  }
  const onClickAction = (item) => {
    clickAction(item.key);
  }
  const onClickLaunch = (item) => {
    navigate({
      resource: RESOURCE,
      action: "addAddons",
      key: selectedInstance.id
    });
  }

  const buttons = [
    <CanAccess resource="addons" action="edit"><Dropdown menu={{ items: lifecycleMenu, onClick: onClickLifecycle }} placement="bottom" arrow>
      <Button>
        <Space>
          {t("addons.menu.state", "Add-on State")}
          <DownOutlined />
        </Space>
      </Button>
    </Dropdown></CanAccess>,
    <CanAccess resource="addons" action="edit"><Dropdown menu={{ items: actionsMenu, onClick: onClickAction }} placement="bottom" arrow>
      <Button>
        <Space>
          {t("addons.menu.actions", "Actions")}
          <DownOutlined />
        </Space>
      </Button>
    </Dropdown></CanAccess>,
    <CanAccess resource="addons" action="edit"><Button onClick={onClickLaunch} disabled={allowEdit?.can == false}>Get more add-ons</Button></CanAccess>,
    <RefreshButton onClick={() => {
      invalidate({
        resource: "addons",
        invalidates: ["list"],
      });
    }}
    />,
  ];

  const invalidate = useInvalidate();
  return (
    <Space>
      { buttons }
    </Space>
  );
};
